/**
 * VISUAL_FRACTION Validator
 *
 * Compares count arrays order-insensitively — [2, 4] matches [4, 2].
 */
import { isEqual, sortBy } from 'lodash';

/** Returns true iff both arrays contain the same multiset of counts. */
export function areVisualFractionCountsEqual(
  expected: number[],
  result?: number[],
): boolean {
  if (!Array.isArray(result)) return false;
  if (expected.length !== result.length) return false;
  return isEqual(sortBy(expected), sortBy(result));
}
